'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useAppSelector } from '@/store/hooks';
import { atualizarConsentimentoMedicao, registrarCadastroConvertido } from '../lib/registrationTracking';
import { selectSelfLeadId, selectSelfMedicaoAutorizada, selectSelfPagamentoStatus } from '../store';

/**
 * Sincroniza a autorização de medição com as tags e registra a conversão só
 * quando o backend confirma a conta (`pagamentoStatus === 'sucesso'`), nunca
 * no envio do formulário.
 *
 * @example
 * useMedicaoCadastro(); // no container do wizard
 */
export const useMedicaoCadastro = () => {
  const $ = _c(8);
  const medicaoAutorizada = useAppSelector(selectSelfMedicaoAutorizada);
  const pagamentoStatus = useAppSelector(selectSelfPagamentoStatus);
  const leadId = useAppSelector(selectSelfLeadId);
  let t0;
  let t1;
  if ($[0] !== medicaoAutorizada) {
    t0 = () => {
      atualizarConsentimentoMedicao(medicaoAutorizada);
    };
    t1 = [medicaoAutorizada];
    $[0] = medicaoAutorizada;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== leadId || $[4] !== medicaoAutorizada || $[5] !== pagamentoStatus) {
    t2 = () => {
      if (pagamentoStatus === "sucesso" && leadId) {
        registrarCadastroConvertido(leadId, medicaoAutorizada);
      }
    };
    t3 = [pagamentoStatus, medicaoAutorizada, leadId];
    $[3] = leadId;
    $[4] = medicaoAutorizada;
    $[5] = pagamentoStatus;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
};